<template>
  <div id="app">
    <!-- Router View to display routed components -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Mason",
};
</script>

<style>
#app {
  max-height: 100dvh;
  overflow-y: hidden;
  font-family: "Inter", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.toastification-success {
  background-color: #f6c22d;
  color: #ffffff;
}
</style>
